import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiTwilioNotEnoughPermissionError } from '@/core/error/transport/tmApiTwilioNotEnoughPermissionError'

export const byocTwilioNotEnoughPermissionErrorRule: CustomErrorRule = {
  subCodes: ['byoc.credentials.twilio.not_enough_permission'],
  klass: TmApiTwilioNotEnoughPermissionError,
}
